import { struct, union } from 'io-ts/Decoder';

import { ParentId } from '../../../../admin/audit-log/ParentId';
import { Id as UserId } from '../../../../user/Id';

export const Params = union(
	struct({
		parentId: ParentId,
	}),
	struct({
		userId: UserId,
	})
);
